import React from 'react';

import {translate} from 'iss/strings';
import {archiveActivations} from 'iss/service/EvaluationActivationService';
import {ActivationList} from 'iss/widgets/ActivationList';
import {ModalForm} from 'iss/widgets/batchOps/ModalForm';
import {listFailuresWithMessage} from 'iss/widgets/batchOps/activation/BatchOpFailure';

const archiveActivation = {
    id: "archive",
    title: "activationOperations.archive.title",
    progressMessage: "activationOperations.archive.progressMessage",
    components: {
      settings: ({operationTargets, onCancel, startOperation}) =>
      <ModalForm proceedText={translate('activationEditor.archive')} proceedLook="danger"
        onSubmit={() => startOperation(archiveActivations(operationTargets))}
        onCancel={onCancel}>
        <p>
          {translate('activationEditor.archivingIsPermanentAndBad')} {" "}
          {translate('activationOperations.archive.confirmMessage', {count: operationTargets.length})}
        </p>
        <ActivationList activations={operationTargets} />
      </ModalForm>,
      success: <p>{translate("activationOperations.archive.success")}</p>,
      failure: listFailuresWithMessage("activationOperations.archive.failure")
    },
};

export default archiveActivation;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/batchOps/activation/archiveActivation.jsx